import { Injector } from '@angular/core';

let appInjectorRef: Injector;
export const getAppInjector = (injector?: Injector): Injector => {
    if (injector) {
        appInjectorRef = injector;
    }
    return appInjectorRef;
};


// WEBPACK FOOTER //
// ./src/angular_library/models/app-injector.ts